import './StrikeZone.scss';

import { ReactComponent as BasePlateUp } from 'svg/BasePlateUp.svg';
import { ReactComponent as BasePlateDown } from 'svg/BasePlateDown.svg';

export type BasePlateOrientation = 'PitcherSide' | 'BatterSide';

type Props = {
  basePlateOrientation: BasePlateOrientation;
  showBufferZone?: boolean;
  showStrikeZoneGrid?: boolean;
  children: React.ReactNode;
};

const StrikeZone = ({ basePlateOrientation, showBufferZone, showStrikeZoneGrid, children }: Props) => {
  return (
    <div className='StrikeZone-container'>
      <div className='StrikeZone-top-space'></div>
      <div className='StrikeZone-rect'>
        {children}
        {showBufferZone && <div className='StrikeZone-rect-buffer'></div>}
        {showStrikeZoneGrid && (
          <div className='StrikeZone-rect-grid'>
            {Array.from({ length: 4 }, (_, i) => i).map((i) => (
              <div key={i} className='StrikeZone-rect-grid-item'></div>
            ))}
          </div>
        )}
      </div>
      <div className='StrikeZone-bottom-space'></div>
      {basePlateOrientation === 'BatterSide' && <BasePlateDown className='StrikeZone-base-plate' />}
      {basePlateOrientation === 'PitcherSide' && <BasePlateUp className='StrikeZone-base-plate' />}
    </div>
  );
};

export default StrikeZone;

export const strikeZoneRangeX = [-8.5, 8.5];
export const strikeZoneRangeY = [15.91, 33.4];

export function getRelativeStrikeZonePointX(x: number): number {
  return ((x - strikeZoneRangeX[0]) / (strikeZoneRangeX[1] - strikeZoneRangeX[0])) * 100;
}

export function getRelativeStrikeZonePointY(y: number): number {
  return ((y - strikeZoneRangeY[0]) / (strikeZoneRangeY[1] - strikeZoneRangeY[0])) * 100;
}

export function generateRandomStrikeZonePoints(amount: number): { x: number; y: number }[] {
  const points: { x: number; y: number }[] = [];
  for (let i = 0; i < amount; i++) {
    points.push({
      x: Math.random() * (strikeZoneRangeX[1] * 2 - strikeZoneRangeX[0] * 2) + strikeZoneRangeX[0] * 2,
      y: Math.random() * (strikeZoneRangeY[1] * 1.25 - strikeZoneRangeY[0] * 0.5) + strikeZoneRangeY[0] * 0.5,
    });
  }
  return points;
}
